import { Route, Routes } from 'react-router';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectUserPermissions, selectUserRoles } from '@store/auth';

import Search from '@assets/images/payment-search/search.png';

import SearchOrders from './pages/search-orders/SearchOrders';

import ApplicationTemplate from '../dashboard/components/ApplicationTemplate/ApplicationTemplate';
import { SidePanelImage } from '../../components/styledComponents';

import { getFirstRoute } from '../../utils/utils';
import { SEARCH_ORDER } from './payment-search.breadcrumbs';
import { ROLES } from '../../app/App.constants';

const tabs = [
  {
    title: 'Search Order',
    icon: <SidePanelImage src={Search} />,
    path: SEARCH_ORDER,
    roles: [ROLES.ROLE_ADMIN, ROLES.ROLE_ORDER_SEARCH_VIEW],
  },
];

function PaymentSearch() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          exact
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="order"
          exact
          element={<SearchOrders permissions={permissions} />}
        />
        <Route
          path="order/:id"
          exact
          element={<SearchOrders permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default PaymentSearch;
